import React, { FC } from 'react';
import { Radio as AntdRadio } from 'antd';
import { RadioProps, RadioGroupProps } from 'antd/lib/radio';

type Props = {
  isGroup?: boolean;
} & (RadioProps | RadioGroupProps);

export const Radio: FC<Props> = (props) => {
  if (props.isGroup) {
    return <AntdRadio.Group {...props} />;
  }

  return <AntdRadio {...props} />;
};
export default Radio;
